import "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import { Chart } from "chart.js";
import { doughnutChartOptions } from "~/misc/charts";

export default class extends Controller {
  connect() {
    const pie_lessons = $('#toJs').data('pielessons');
    //p(hours_vs_age);
    //Chart.defaults.global.elements.line.borderWidth = 1.5;
    //Chart.defaults.global.elements.point.radius = 3;

    const colors = ["#109618", "#ff9900", "#DC3912"];
    const ctx = $('#pie')[0] as HTMLCanvasElement;
    const options = Object.assign({}, doughnutChartOptions);
    options.plugins!.tooltip!.callbacks = {
      label(context) {
        const value = context.parsed as number;
        return `${value}/${pie_lessons.count} (${Math.round(value / pie_lessons.count * 100)}%)`;
      },
    };
    new Chart(ctx, {
      type: 'doughnut',
      data: {
        datasets: [{
          data: pie_lessons.data,
          backgroundColor: colors,
          borderColor: colors
        }],
        labels: pie_lessons.labels
      },
      options: options
    });

    const column_lessons = $('#toJs').data('columnlessons');
    const ctx2 = $('#column1')[0] as HTMLCanvasElement;
    new Chart(ctx2, {
      type: 'line',
      data: {
        datasets: [{
          borderColor: "#dc3912",
          pointBackgroundColor: "#dc3912",
          pointBorderColor: "#dc3912",
          data: column_lessons
        }]
      },
      options: {
        datasets: {
          line: {
            borderWidth: 1.5
          }
        },
        scales: {
          x: {
            type: 'time',
            time: {
              unit: 'day',
              tooltipFormat: 'YYYY.MM.DD',
              displayFormats: {
                minute: 'HH:mm',
                hour: 'MM.DD HH:mm',
                day: 'MM.DD'
              }
            }
          },
          y: {
            title: {
              display: true,
              text: 'Résztvevők száma'
            },
            min: 0
          }
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: function (context) {
                return context.parsed.y + ' fő';
              }
            }
          },
          legend: {
            display: false
          }
        },
        responsive: true,
        maintainAspectRatio: false,
      }
    });

    const column_students = $('#toJs').data('columnstudents');
    const ctx3 = $('#column2')[0] as HTMLCanvasElement;
    new Chart(ctx3, {
      type: 'bar',
      data: {
        datasets: [{
          backgroundColor: colors[0],
          borderColor: colors[0],
          data: column_students.data,
        }],
        labels: column_students.labels,
      },
      options: {
        indexAxis: 'y',
        scales: {
          x: {
            min: 0,
          },
          y: {
            //maxBarThickness: 40,
          },
        },
        plugins: {
          title: {
            display: true,
            text: 'Abszolút jelenlét (alkalom)',
            position: 'bottom',
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                return context.raw + ' alkalmon volt jelen';
              }
            }
          },
          legend: {
            display: false
          }
        },
        maintainAspectRatio: false,
      }
    });

    const column_students2 = $('#toJs').data('columnstudents2');
    const ctx4 = $('#column3')[0] as HTMLCanvasElement;
    new Chart(ctx4, {
      type: 'bar',
      data: {
        datasets: [{
          backgroundColor: "#3366cc",
          borderColor: "#3366cc",
          data: column_students2.data,
        }],
        labels: column_students2.labels,
      },
      options: {
        indexAxis: 'y',
        scales: {
          x: {
            min: 0,
          },
          y: {
            //maxBarThickness: 40,
          },
        },
        plugins: {
          title: {
            display: true,
            text: 'Relatív jelenlét (%)',
            position: 'bottom',
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                return Math.round(context.raw as number) +
                  '% (' + column_students2.d1[context.dataIndex] +
                  '/' + column_students2.d2[context.dataIndex] + ')';
              }
            }
          },
          legend: {
            display: false
          }
        },
        maintainAspectRatio: false,
      }
    });
  }
}